import React, { useEffect, useMemo } from 'react';
import { Box, Button, Paper, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { map } from 'lodash';
import TopBar from '../../../components/TopBar';
import CustomTextInput from '../../../components/CustomTextInput';

function buildMeterSchema(isEdit, readOnly) {
  return yup.object({
    display_name: yup.string().required('Display name is required'),
    event_name: readOnly || isEdit ? yup.string().nullable() : yup.string().required('Event name is required'),
  });
}

export default function MeterForm({
  onSubmit = () => {},
  onCancel,
  initialData = {},
  apiErrors = {},
  readOnly = false,
  isEdit = false,
  isLoading = false,
}) {
  const schema = useMemo(() => buildMeterSchema(isEdit, readOnly), [isEdit, readOnly]);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      meter_id: initialData.meter_id || '',
      display_name: initialData.display_name || '',
      event_name: initialData.event_name || '',
      aggregation_formula: initialData.aggregation_formula || 'sum',
    },
  });

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = methods;

  useEffect(() => {
    map(apiErrors, (value, key) => setError(key, { message: value, type: 'string' }));
  }, [apiErrors, setError]);

  return (
    <FormProvider {...methods}>
      <Paper elevation={0} sx={{ p: '1rem' }}>
        {!readOnly && (
          <Box sx={{ pt: 2, pb: 3 }}>
            <TopBar title="Meter Form" identifier={initialData.meter_id}>
              <Stack direction="row" spacing={1}>
                <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleSubmit(onSubmit)} disabled={isLoading}>
                  Save
                </Button>
              </Stack>
            </TopBar>
          </Box>
        )}
        <Grid container spacing={2}>
          <Grid size={6}>
            <CustomTextInput
              name="display_name"
              label="Display Name"
              control={control}
              errors={errors}
              readOnly={readOnly}
              disabled={readOnly}
            />
          </Grid>
          <Grid size={6}>
            <CustomTextInput
              name="event_name"
              label="Event Name"
              control={control}
              errors={errors}
              readOnly={readOnly}
              disabled={isEdit}
            />
          </Grid>
        </Grid>
      </Paper>
    </FormProvider>
  );
}
